import React, { useState } from 'react';
import { CheckIcon } from '@heroicons/react/24/solid';
import { Helmet } from 'react-helmet';  // Importera Helmet

function FlyttstadningBase({ rubrikOne, rubrikTwo, city, backgroundImage, backgroundOpacityClass }) {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    area: ''
  });
  const sanitizeCity = (name) => {
    return name.toLowerCase().replace(/\s+/g, '-');
    };
  const canonicalUrl = `https://provalt.se/flyttstadning-i-${sanitizeCity(city)}`;

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
const [successMessage, setSuccessMessage] = useState('');

const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const response = await fetch('/backend/flytt/offert-send.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });

    const text = await response.text();
    console.log('Svar från servern:', text); // 🪵 Lägg till logg här

    if (!response.ok) {
      throw new Error(`Serverfel: ${response.status}`);
    }

    setSuccessMessage(  'Offerten har skickats till din e-postadress!\nKontrollera även din skräppost om du inte ser den inom några minuter.');
    setFormData({ name: '', email: '', area: '' });

    if (typeof window.gtag_report_conversion === 'function') {
      window.gtag_report_conversion();
    }
  } catch (error) {
    setSuccessMessage('Något gick fel. Försök igen senare.');
    console.error('Fel vid formulärsändning:', error);
  }
};


  return (
    <>
        <Helmet>
        <title>Flyttstädning i {city} - Provalt Service AB</title>
        <meta name="description" content="Professionell och noggrann flyttstädning för ditt hem eller kontor. 
          Vi ser till att ditt gamla boende är skinande rent inför nästa hyresgäst eller köpare." />
            <link rel="canonical" href={canonicalUrl} />

      </Helmet>
      {/* Hero */}
      <section
        className="w-full h-[600px] bg-cover bg-center px-4 sm:px-8 relative overflow-hidden"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      >
        <div className={`absolute inset-0 bg-black ${backgroundOpacityClass} z-0`}></div>
        <div className="flex items-center justify-center h-full relative z-10">
          <div className="text-center text-white max-w-7xl mx-auto bg-black p-3 bg-opacity-40">
            <h1 className="text-4xl sm:text-5xl md:text-5xl lg:text-5xl font-bold mb-4">
              Professionell flyttstädning i {city}
            </h1>
            <h2 className="text-2xl mb-4">
              {rubrikOne}
            </h2>
            <h2 className="text-2xl mb-4 font-">
              {rubrikTwo}
            </h2>
          
            <h2 className="text-2xl mb-4 font-bold">

              Kostnadsfritt offert inom 1 minut!
            </h2>
            <button onClick={() => document.getElementById('offer_section')?.scrollIntoView({ behavior: 'smooth' })}
              className="inline-block text-xl mt-4 px-5 py-3 font-bold text-white bg-[#0693e3] rounded">
              Begär offert
            </button>
          </div>
        </div>
      </section>

      {/* Kostnadsfri offert */}
      <section className="w-full px-4 sm:px-8 py-16 bg-white" id="offer_section">
        <h2 className="text-3xl font-bold mb-4 text-center py-5">Kostnadsfri offert</h2>
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center">
          <div className="w-full md:w-1/2 text-center md:text-left mb-8 md:mb-0 p-4">
            <p className="text-xl mb-4">
              <b>Vi Gör Flyttstädningen Enklare för Dig!</b><br /><br />
              Många tycker att flyttstädning är tidskrävande och stressigt, särskilt när viktiga detaljer lätt förbises.<br /><br />
              Det är här vi på Provalt Service AB kommer in – vi gör städningen enkel och smidig för dig!
            </p>
            <h3 className="text-2xl font-semibold mb-2">Varför välja oss?</h3>
            <ul className="text-xl mb-4 space-y-2">
              <li className="flex items-center">
                <CheckIcon className="w-5 h-5 text-green-500 mr-2" /> Inga dolda avgifter
              </li>
              <li className="flex items-center">
                <CheckIcon className="w-5 h-5 text-green-500 mr-2" /> Miljövänliga metoder
              </li>
              <li className="flex items-center">
                <CheckIcon className="w-5 h-5 text-green-500 mr-2" /> Kundnöjdhets-garanti
              </li>
            </ul>
            <p className="text-xl mb-4">
              Om du har några frågor om RUT-avdraget, tveka inte att kontakta oss – vi hjälper gärna till att förklara hur det fungerar.
            </p>
          </div>

          {/* Formulär */}
          <div className="w-full md:w-1/2 bg-white p-12 rounded shadow-2xl">
          {/*Rabattdelen*/}
          <div className="bg-zinc-100 border-l-4 border-zinc-100 text-black text-center p-4 rounded mb-6 shadow">
            <p className="font-semibold">🔔 Sommarrabatt t.o.m. 30 juni!</p>
            <p>Just nu får du <strong>10% rabatt</strong> på flyttstädning – gäller alla bokningar som görs innan <strong>30 juni 2025</strong>.</p>
          </div>
          {/*Rabattdelen upp*/}
            <h3 className="text-2xl font-semibold mb-6">Flyttstädning – Få offert inom 1 minut</h3>
            <form onSubmit={handleSubmit}>
              <div className="mb-4">
                <label htmlFor="name" className="block text-lg mb-2">Namn (Obligatoriskt)</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full p-3 border border-gray-300 rounded"
                />
              </div>
              <div className="mb-4">
                <label htmlFor="email" className="block text-lg mb-2">E-post (Obligatoriskt)</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full p-3 border border-gray-300 rounded"
                />
              </div>
              <div className="mb-4">
                <label htmlFor="area" className="block text-lg mb-2">Antal kvm (Obligatoriskt)</label>
                <input
                  type="number"
                  id="area"
                  name="area"
                  value={formData.area}
                  onChange={handleChange}
                  required
                  className="w-full p-3 border border-gray-300 rounded"
                />
              </div>
              <button type="submit" className="w-full px-4 py-2 bg-green-500 text-white font-semibold rounded">
                Skicka min offert
              </button>
              {successMessage && (
                <p className="text-green-600 mt-4 font-medium">{successMessage}</p>
              )}
            </form>
          </div>
        </div>
      </section>

      {/* Det här ingår i flyttstädning */}
      <section className="w-full py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-2xl font-bold text-gray-800 mb-12 text-center" id="checklist">Det här ingår i flyttstädning</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 text-gray-700">
            {/* Badrum & Kök */}
            <div className="flex flex-col space-y-8">
              <div>
                <h3 className="text-xl font-semibold mb-2 text-green-700">Badrum</h3>
                <ul className="list-disc list-inside space-y-1">
                  <li>Avtorkning av toalettstol, dusch/badkar samt alla lampor som nås</li>
                  <li>Rengöring av handfat (även undersidan), kranar och rör</li>
                  <li>Golvet dammsugs och våttorkas</li>
                  <li>Puts av speglar</li>
                  <li>Badrumsmöbler torkas utvändigt och invändigt</li>
                </ul>
              </div>
              <div>
                <h3 className="text-xl font-semibold mb-2 text-green-700">Kök</h3>
                <ul className="list-disc list-inside space-y-1">
                  <li>Avtorkning av kakel och köksluckor</li>
                  <li>Invändig rengöring av köksskåp</li>
                  <li>Dammtorkning av golvlister, socklar och fasta lampor</li>
                  <li>Diskho och kranar rengörs</li>
                </ul>
              </div>
            </div>

            {/* Sovrum, Allrum, Övrigt */}
            <div className="flex flex-col space-y-8">
              <div>
                <h3 className="text-xl font-semibold mb-2 text-green-700">Sovrum</h3>
                <ul className="list-disc list-inside space-y-1">
                  <li>Dammtorkning av alla öppna ytor och eluttag/kontakter</li>
                  <li>Garderober och fasta skåp rengörs in- och utvändigt</li>
                  <li>Golv dammsugs och våttorkas</li>
                </ul>
              </div>
              <div>
                <h3 className="text-xl font-semibold mb-2 text-green-700">Allrum</h3>
                <ul className="list-disc list-inside space-y-1">
                  <li>Dammtorkning av alla öppna ytor och kontakter</li>
                  <li>Garderober, skrubbar och fasta skåp rengörs</li>
                  <li>Golv dammsugs och våttorkas</li>
                </ul>
              </div>
              <div>
                <h3 className="text-xl font-semibold mb-2 text-green-700">Övrigt</h3>
                <ul className="list-disc list-inside space-y-1">
                  <li>Fönsterputs i alla rum</li>
                  <li>Rengöring av fria ytor: lister, väggar, element, strömbrytare</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Tilläggstjänster */}
      <section className="w-full max-w-4xl mx-auto px-6 py-16">
        <h3 className="text-2xl font-bold text-gray-800 mb-6 text-center">Tilläggstjänster</h3>
        <div className="overflow-x-auto">
          <table className="min-w-full table-auto border border-gray-200">
            <thead>
              <tr className="bg-gray-100 text-left text-gray-700">
                <th className="px-4 py-3 border-b">Yta</th>
                <th className="px-4 py-3 border-b">Pris (innan RUT-avdrag)</th>
                <th className="px-4 py-3 border-b">Ditt pris</th>
              </tr>
            </thead>
            <tbody className="text-gray-700">
              <tr className="hover:bg-gray-50">
                <td className="px-4 py-3 border-b">Garage</td>
                <td className="px-4 py-3 border-b">498 kr</td>
                <td className="px-4 py-3 border-b">249 kr</td>
              </tr>
              <tr className="hover:bg-gray-50">
                <td className="px-4 py-3 border-b">Källare/Vind</td>
                <td className="px-4 py-3 border-b">498 kr</td>
                <td className="px-4 py-3 border-b">249 kr</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      {/* Kontakt */}
      <section className="w-full bg-cover bg-center bg-no-repeat relative py-32" style={{ backgroundImage: "url('/images/cleaning/moving.webp')" }}>
        <div className="absolute inset-0 bg-black/50"></div> {/* Mörk overlay */}
        <div className="relative z-10 max-w-3xl mx-auto text-center px-6">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">Några frågor?</h2>
          <p className="text-lg md:text-xl text-white">
            Tveka inte att kontakta oss på <a href="mailto:info@provalt.se" className="underline hover:text-green-300">info@provalt.se</a>
          </p>
        </div>
      </section>
    </>
  );
}

export default FlyttstadningBase;
